import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

/**
 * QR + Barcode scanner. Calls onScan(text) once per detection.
 * Uses back camera by default.
 */
export default function QRScanner({ onScan, onError }) {
  const containerId = "imsyaf-qr-reader";
  const scannerRef = useRef(null);

  useEffect(() => {
    const scanner = new Html5Qrcode(containerId, { verbose: false });
    scannerRef.current = scanner;
    let stopped = false;

    Html5Qrcode.getCameras()
      .then((cams) => {
        if (!cams || cams.length === 0) {
          onError && onError("Kamera tidak ditemukan");
          return;
        }
        const back = cams.find((c) => /back|belakang|rear|environment/i.test(c.label)) || cams[cams.length - 1];
        scanner
          .start(
            back.id,
            { fps: 12, qrbox: { width: 260, height: 200 } },
            (decoded) => {
              if (stopped) return;
              stopped = true;
              onScan && onScan(decoded);
              scanner.stop().catch(() => {});
            },
            () => {}
          )
          .catch((e) => onError && onError(e.message || String(e)));
      })
      .catch((e) => onError && onError(e.message || String(e)));

    return () => {
      try {
        if (scanner && scanner.isScanning) scanner.stop().catch(() => {});
      } catch (_) {}
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="w-full">
      <div id={containerId} data-testid="qr-scanner-view" className="w-full max-w-md mx-auto rounded-lg overflow-hidden bg-black" />
      <p className="text-xs text-slate-500 mt-2 text-center">Arahkan kamera ke QR Code atau Barcode 1D santri.</p>
    </div>
  );
}
